import React from 'react'

const Avatar = ({ text, bg_color }) => {
  let colors = [
    'red',
    'orange',
    'yellow',
    'green',
    'blue',
    'purple',
    'pink',
    'black',
    'white',
    'gray',
  ]

  const color_selected =
    colors.filter((cl) => cl.includes(text.toLowerCase()))?.length > 0
      ? colors.filter((cl) => cl.includes(text.toLowerCase()))[0]
      : colors.filter((cl) => cl.includes(text.slice(0, 1).toLowerCase()))?.length > 0
      ? colors.filter((cl) => cl.includes(text.slice(0, 1).toLowerCase()))[0]
      : colors[0]
  return (
    <div
      className=" h-10 w-10 flex items-center justify-center rounded-full p-2 text-white text-sm font-semibold "
      style={{ backgroundColor: color_selected }}
    >
      {text}
    </div>
  )
}

export default Avatar
